"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonStateMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @mixin buttonStateMixin */
/**
 * @method
 */
var buttonStateMixin = function buttonStateMixin(state) {
  if (state === void 0) {
    state = '';
  }
  return function (props) {
    var buttonType = props.buttonType,
      inverse = props.inverse,
      bare = props.bare,
      borderless = props.borderless;
    var variant = "" + buttonType + (inverse ? 'Inverse' : '');
    return (0, _styledToken.default)({
      backgroundColor: "Button." + variant + ".backgroundColor" + state,
      borderColor: "Button." + variant + ".borderColor" + state,
      color: "Button." + variant + ".fontColor" + state
    }, function (_ref) {
      var backgroundColor = _ref.backgroundColor,
        borderColor = _ref.borderColor,
        color = _ref.color;
      var currentState = /*#__PURE__*/(0, _styledComponents.css)(["background-color:", ";border-color:", ";color:", ";"], backgroundColor, borderless && state !== 'Pressed' ? 'transparent' : borderColor, color);
      if (bare) {
        currentState = (0, _styledComponents.css)(["background-color:", ";border-color:", ";color:", ";"], state === '' ? 'transparent' : backgroundColor, state !== 'Pressed' ? 'transparent' : borderColor, color);
      }
      return currentState;
    })(props);
  };
};
exports.buttonStateMixin = buttonStateMixin;